class AxiosRequest {
  constructor() {
    this.user = null
    this.accessTokenPromise = null
    this.accessToken = null
  }

  setUserToken = (authUser) => {
    this.user = authUser
    const tokenPromise = authUser.getIdToken
      ? authUser.getIdToken()
      : Promise.resolve()
    this.accessTokenPromise = tokenPromise
    tokenPromise.then((newAccessToken) => {
      if (this.accessTokenPromise === tokenPromise) {
        this.accessToken = newAccessToken
        this.accessTokenPromise = null
      }
    })
  }

  watchOutgoing = (config) => {
    if (this.accessTokenPromise) {
      return this.accessTokenPromise.then(this.getConfig(config))
    }
    return this.getConfig(config)()
  }

  getConfig = (config) => {
    return (newAccessToken) => {
      if (!config.headers) {
        config.headers = {}
      }
      const token = newAccessToken || this.accessToken
      config.headers.Authorization = 'Bearer ' + token
      return config
    }
  }
}

export default new AxiosRequest()
